// extracted by mini-css-extract-plugin
export default {"labelList":"labels-field-module__labelList--o3oGW"};